import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import {
	MISSION_TYPE_REUNION_TYPE,
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Solution } from '../models/solution';
import { DateUtils } from './date-utils';

@Injectable()
export class ExportPdfUtils {
	labelBeneficiaireCapitalized: string;
	labelIntervenantCapitalized: string;
	isMissionPlacesActive: boolean;

	constructor(private dateUtils: DateUtils, private facade: FacadeService) {
		this.labelBeneficiaireCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);
		this.labelIntervenantCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.isMissionPlacesActive = this.facade.dataStorageService.isSESSAD();
	}

	exportAsPDF(divId: string, ddEmployee: string) {
		const data = document.getElementById(divId);
		html2canvas(data).then((canvas) => {
			const contentDataURL = canvas.toDataURL('image/png');
			const pdf = new jsPDF('l', 'cm', 'a5'); // Generates PDF in landscape mode
			// let pdf = new jspdf('p', 'cm', 'a4'); Generates PDF in portrait mode
			pdf.addImage(
				contentDataURL,
				'PNG',
				0,
				0,
				pdf.internal.pageSize.getWidth(),
				pdf.internal.pageSize.getHeight(),
				'planning',
				'NONE'
			);
			pdf.save(`planning_${ddEmployee}.pdf`);
		});
	}

	exportAsListPDF(
		solution: Solution,
		selectedWeek: number,
		beginDate: Date,
		endDate: Date,
		ddEmployeeId?: number
	) {
		const doc = new jsPDF();
		const col = [
			this.labelBeneficiaireCapitalized,
			'Date et horaires',
			'Lieu de prestation',
			'Notes'
		].filter((x) => x !== undefined);
		let rows = [];

		if (solution && solution.plannings.length > 0) {
			if (ddEmployeeId) {
				const employeeSelectedPlanning = solution.plannings.find((planning) => {
					return planning.employee.id === ddEmployeeId;
				});
				if (
					employeeSelectedPlanning.routes &&
					employeeSelectedPlanning.routes
						.flatMap((route) => route.missions)
						.some((mission) => mission.missionRequest !== null)
				) {
					const employeeName =
						employeeSelectedPlanning.employee.firstName +
						' ' +
						employeeSelectedPlanning.employee.lastName;
					employeeSelectedPlanning.routes
						.flatMap((route) => route.missions)
						.sort(
							(mission1, mission2) =>
								new Date(mission1.missionRequest.date).getTime() -
								new Date(mission2.missionRequest.date).getTime() +
								mission1.realStart -
								mission2.realStart
						)
						.forEach((mission) => {
							const row = [
								(mission.missionRequest.beneficiaire
									? mission.missionRequest.beneficiaire.firstName
									: '-') +
									' ' +
									(mission.missionRequest.beneficiaire
										? mission.missionRequest.beneficiaire.lastName
										: '-'),
								new Date(mission.missionRequest.date).toLocaleDateString(
									'fr-FR'
								) +
									'\n' +
									this.dateUtils.timeConvert(mission.missionRequest.readyTime) +
									' - ' +
									this.dateUtils.timeConvert(mission.missionRequest.dueTime),
								mission.missionRequest.missionPlace
									? mission.missionRequest.missionPlace.nameDisplay +
									  '\n' +
									  mission.missionRequest.missionPlace.address.label
									: mission.missionRequest.beneficiaire
									? 'Domicile du bénéficiaire' +
									  '\n' +
									  mission.missionRequest?.beneficiaire?.address?.label
									: mission.missionRequest.missionType.type,
								mission.missionRequest.notes
							].filter((x) => x !== undefined);
							rows.push(row);
						});
					doc.text(
						'Planning de ' +
							employeeName +
							', Semaine n°' +
							selectedWeek +
							' : ' +
							beginDate.getDate() +
							'/' +
							(beginDate.getMonth() + 1) +
							'/' +
							beginDate.getFullYear() +
							'-' +
							endDate.getDate() +
							'/' +
							(endDate.getMonth() + 1) +
							'/' +
							endDate.getFullYear(),
						7,
						15
					);

					autoTable(doc, {
						columns: col,
						body: rows,
						startY: 20,
						margin: { horizontal: 7 },
						headStyles: { cellWidth: 'wrap' },
						columnStyles: { text: { overflow: 'linebreak' } },
						bodyStyles: { overflow: 'linebreak' }
					});
					rows = [];
				}
				doc.save(
					`Planning_List_${employeeSelectedPlanning.employee.firstName}_${employeeSelectedPlanning.employee.lastName}_Week_${selectedWeek}.pdf`
				);
			} else {
				solution.plannings.forEach((planning, index) => {
					if (
						planning.routes &&
						planning.routes
							.flatMap((route) => route.missions)
							.some((mission) => mission.missionRequest !== null)
					) {
						const employeeName =
							planning.employee.firstName + ' ' + planning.employee.lastName;
						planning.routes
							.flatMap((route) => route.missions)
							.sort(
								(mission1, mission2) =>
									new Date(mission1.missionRequest.date).getTime() -
									new Date(mission2.missionRequest.date).getTime() +
									mission1.realStart -
									mission2.realStart
							)
							.forEach((mission) => {
								const row = [
									(mission.missionRequest.beneficiaire
										? mission.missionRequest.beneficiaire.firstName
										: '-') +
										' ' +
										(mission.missionRequest.beneficiaire
											? mission.missionRequest.beneficiaire.lastName
											: '-'),
									new Date(mission.missionRequest.date).toLocaleDateString(
										'fr-FR'
									) +
										'\n' +
										this.dateUtils.timeConvert(
											mission.missionRequest.readyTime
										) +
										' - ' +
										this.dateUtils.timeConvert(mission.missionRequest.dueTime),
									mission.missionRequest.missionPlace
										? mission.missionRequest.missionPlace.nameDisplay +
										  '\n' +
										  mission.missionRequest.missionPlace.address.label
										: mission.missionRequest.beneficiaire
										? 'Domicile du bénéficiaire' +
										  '\n' +
										  mission.missionRequest?.beneficiaire?.address?.label
										: mission.missionRequest.missionType.type,
									mission.missionRequest.notes
								].filter((x) => x !== undefined);
								rows.push(row);
							});
						doc.text(
							'Planning de ' +
								employeeName +
								', Semaine n°' +
								selectedWeek +
								' : ' +
								beginDate.getDate() +
								'/' +
								(beginDate.getMonth() + 1) +
								'/' +
								beginDate.getFullYear() +
								'-' +
								endDate.getDate() +
								'/' +
								(endDate.getMonth() + 1) +
								'/' +
								endDate.getFullYear(),
							7,
							15
						);
						autoTable(doc, {
							columns: col,
							body: rows,
							startY: 20,
							margin: { horizontal: 7 },
							headStyles: { cellWidth: 'wrap' },
							columnStyles: { text: { overflow: 'linebreak' } },
							bodyStyles: { overflow: 'linebreak' }
						});
						if (index !== solution.plannings.length - 1) {
							doc.addPage();
						}
						rows = [];
					}
				});
				doc.save(
					`Planning_List_All${this.labelIntervenantCapitalized}s_Week_${selectedWeek}.pdf`
				);
			}
		}
		// }
		// TODO: case for just 1 employee
	}

	exportReportBeneficiaireMonth(
		statsBeneficiaire: {
			fullName: string;
			competence: any;
			numberFormation: number;
			numberReunion: number;
			distanceParcourue: number;
			tempsFaceAFace: number;
			tempsMissionsAnnexes: number;
			tempsTrajet: number;
			tempsAdministratifAndPreparation: number;
			tempsReunion: number;
			tempsTravailTotal: number;
		}[],
		date: Date
	) {
		const doc = new jsPDF();
		const col = [
			this.labelBeneficiaireCapitalized,
			'Nombre de prestation',
			'Temps de face à face'
		];

		let rows = [];

		statsBeneficiaire.forEach((stats) => {
			const formattedFaceToFaceTime = this.dateUtils.timeConvert(
				stats.tempsFaceAFace
			);
			const row = [
				stats.fullName,
				stats.numberFormation,
				formattedFaceToFaceTime
			];
			rows.push(row);
		});

		var monthName = new Intl.DateTimeFormat('fr-FR', { month: 'long' }).format;
		var longName = monthName(date); // "July"

		doc.text(
			"Rapport d'activité " + longName + ' ' + date.getFullYear(),
			7,
			15
		);

		autoTable(doc, {
			columns: col,
			body: rows,
			startY: 20,
			margin: { horizontal: 7 },
			headStyles: { cellWidth: 'wrap' },
			columnStyles: { text: { overflow: 'linebreak' } },
			bodyStyles: { overflow: 'linebreak' }
		});
		rows = [];

		doc.save(
			`Rapport_activite_${date.getMonth()}_${date.getFullYear()}_beneficiaire.pdf`
		);
	}

	exportReportEmployeeMonth(
		statsEmployee: {
			fullName: string;
			competence: any;
			numberFormation: number;
			numberReunion: number;
			distanceParcourue: number;
			tempsFaceAFace: number;
			tempsMissionsAnnexes: number;
			tempsTrajet: number;
			tempsAdministratifAndPreparation: number;
			tempsReunion: number;
			tempsTravailTotal: number;
		}[],
		date: Date
	) {
		const doc = new jsPDF();
		const col = [
			this.labelBeneficiaireCapitalized,
			'Nombre de prestation',
			'Distance parcourue',
			'Temps de face à face'
		];

		let rows = [];

		statsEmployee.forEach((stats) => {
			// on ignore les stats non global, et les stats où il y a juste des réunions (donc pas de temps de face à face)
			if (
				(stats.fullName === 'Total' && stats.competence !== 'Global') ||
				stats.tempsFaceAFace === 0
			) {
				return;
			}
			const formattedFaceToFaceTime = this.dateUtils.timeConvert(
				stats.tempsFaceAFace
			);
			const distanceInKms = Math.round(stats.distanceParcourue / 1000);
			const row = [
				stats.fullName,
				stats.numberFormation,
				distanceInKms,
				formattedFaceToFaceTime
			];
			rows.push(row);
		});

		var monthName = new Intl.DateTimeFormat('fr-FR', { month: 'long' }).format;
		var longName = monthName(date); // "July"

		doc.text(
			"Rapport d'activité " + longName + ' ' + date.getFullYear(),
			7,
			15
		);

		autoTable(doc, {
			columns: col,
			body: rows,
			startY: 20,
			margin: { horizontal: 7 },
			headStyles: { cellWidth: 'wrap' },
			columnStyles: { text: { overflow: 'linebreak' } },
			bodyStyles: { overflow: 'linebreak' }
		});
		rows = [];

		doc.save(
			`Rapport_activite_${date.getMonth()}_${date.getFullYear()}_intervenant.pdf`
		);
	}
}
